import Types from "./types";

export default () => ({
	type: Types.NOTIFICATIONS_DIALOG_CLOSE_CLICKED,
});
